export default __webpack_public_path__ + "static/media/fridge1-before2-480w.86ddc414.avif";